/**
 * Pricing page - Green/black theme, PublicPageLayout.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../providers';
import { PublicPageLayout } from '../components/public';

const Pricing = () => {
  const navigate = useNavigate();
  const { language } = useI18n();

  const features = [
    language === 'fr' ? '1,5% par transaction (plafonné 15 000 XAF)' : '1.5% per transaction (capped 15,000 XAF)',
    language === 'fr' ? 'Paiements MTN MoMo, Orange Money, carte' : 'MTN MoMo, Orange Money, card payments',
    language === 'fr' ? 'Escrow sécurisé jusqu\'à confirmation' : 'Secure escrow until confirmation',
    language === 'fr' ? 'Support litiges et médiation' : 'Dispute support and mediation',
  ];

  return (
    <PublicPageLayout>
      <button type="button" onClick={() => navigate('/')} className="public-page-back">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
        {language === 'fr' ? "Retour à l'accueil" : 'Back to Home'}
      </button>

      <div className="public-page-hero">
        <h1 className="public-page-title">{language === 'fr' ? 'Tarifs' : 'Pricing'}</h1>
        <p className="public-page-sub">
          {language === 'fr' ? 'Tarification simple et transparente.' : 'Simple, transparent pricing.'}
        </p>
      </div>

      <div className="public-page-section">
        <div className="public-page-card" style={{ textAlign: 'center', padding: '2rem', maxWidth: '28rem', margin: '0 auto 1.5rem' }}>
          <div className="public-page-stat-num" style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>1.5%</div>
          <div className="public-page-stat-label" style={{ marginBottom: '1rem' }}>
            {language === 'fr' ? 'par transaction (max 15 000 XAF)' : 'per transaction (max 15,000 XAF)'}
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem', textAlign: 'left' }}>
            {features.map((f, i) => (
              <li key={i} style={{ fontSize: '0.9375rem', color: 'var(--pub-muted)', padding: '0.35rem 0', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <span style={{ color: 'var(--pub-green)' }}>✓</span> {f}
              </li>
            ))}
          </ul>
          <button type="button" onClick={() => navigate('/auth/signup')} className="public-page-cta">
            {language === 'fr' ? 'Commencer' : 'Get Started'}
          </button>
        </div>
        <p className="public-page-card-desc" style={{ textAlign: 'center' }}>
          {language === 'fr' ? 'Tarifs et plans détaillés à venir.' : 'Detailed plans coming soon.'}
        </p>
      </div>
    </PublicPageLayout>
  );
};

export default Pricing;
